import { EventEmitter, Injectable, QueryList } from '@angular/core';
import { VgUtils } from './vg-utils';
import { VgMedia } from '../vg-media/vg-media';
import { Subscription, fromEvent } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class VgFullscreenAPI {
    static fakeFullScreen = false;

    polyfill: any;
    onchange: string;
    onerror: string;
    nativeFullscreen: boolean = true;
    isFullscreen: boolean = false;
    isAvailable: boolean;
    videogularElement: HTMLElement;
    medias: QueryList<VgMedia>;
    fsChangeSubscription: Subscription;
    padChangeSubscription: Subscription;
    appChangeSubscription: Subscription;

    onChangeFullscreen: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    init(elem: HTMLElement, medias: QueryList<VgMedia>) {
        if (this.fsChangeSubscription != null) {
            this.fsChangeSubscription.unsubscribe();
        }
        if (this.padChangeSubscription != null) {
            this.padChangeSubscription.unsubscribe();
        }

        if(this.appChangeSubscription !=null)
        {
            this.appChangeSubscription.unsubscribe();
        }
        this.videogularElement = elem;
        this.medias = medias;
        const APIs = {
            w3: {
                enabled: 'fullscreenEnabled',
                element: 'fullscreenElement',
                request: 'requestFullscreen',
                exit: 'exitFullscreen',
                onchange: 'fullscreenchange',
                onerror: 'fullscreenerror'
            },
            newWebkit: {
                enabled: 'webkitFullscreenEnabled',
                element: 'webkitFullscreenElement',
                request: 'webkitRequestFullscreen',
                exit: 'webkitExitFullscreen',
                onchange: 'webkitfullscreenchange',
                onerror: 'webkitfullscreenerror'
            },
            oldWebkit: {
                enabled: 'webkitIsFullScreen',
                element: 'webkitCurrentFullScreenElement',
                request: 'webkitRequestFullScreen',
                exit: 'webkitCancelFullScreen',
                onchange: 'webkitfullscreenchange',
                onerror: 'webkitfullscreenerror'
            },
            moz: {
                enabled: 'mozFullScreen',
                element: 'mozFullScreenElement',
                request: 'mozRequestFullScreen',
                exit: 'mozCancelFullScreen',
                onchange: 'mozfullscreenchange',
                onerror: 'mozfullscreenerror'
            },
            ios: {
                enabled: 'webkitFullscreenEnabled',
                element: 'webkitFullscreenElement',
                request: 'webkitEnterFullscreen',
                exit: 'webkitExitFullscreen',
                onchange: 'webkitendfullscreen', // Hack for iOS: webkitfullscreenchange it's not firing
                onerror: 'webkitfullscreenerror'
            },
            ms: {
                enabled: 'msFullscreenEnabled',
                element: 'msFullscreenElement',
                request: 'msRequestFullscreen',
                exit: 'msExitFullscreen',
                onchange: 'MSFullscreenChange',
                onerror: 'MSFullscreenError'
            }
        };

        for (let browser in APIs) {
            if (APIs[browser].enabled in document) {
                this.polyfill = APIs[browser];
                break;
            }
        }

        if (VgUtils.isiOSDevice()) {
            this.polyfill = APIs.ios
        }

        this.isAvailable = (this.polyfill != null);

        if (this.polyfill == null) {
            return;
        }

        //console.log(this.polyfill);

        let fsElemDispatcher;

        switch (this.polyfill.onchange) {
            // Mozilla dispatches the fullscreen change event from document, not the element
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=724816#c3
            case 'mozfullscreenchange':
                fsElemDispatcher = document;
                break;

            // iOS dispatches the fullscreen change event from video element
            case 'webkitendfullscreen':
                try {
                    fsElemDispatcher = this.medias.toArray()[0].elem;
                }
                catch (err) {
                    return;
                }
                break;

            // HTML5 implementation dispatches the fullscreen change event from the element
            default:
                //alert(this.polyfill.onchange);
                fsElemDispatcher = elem;
                break;
        }

        if (VgUtils.isSafari()) {
            var timeout = null;
            var mediaList = this.medias.toArray();
            this.padChangeSubscription = fromEvent(mediaList.length>0?mediaList[0].elem:fsElemDispatcher, "webkitendfullscreen").subscribe(() => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.onFullscreenChange();
                }, 200);

            });
            this.fsChangeSubscription = fromEvent(fsElemDispatcher, this.polyfill.onchange)
                .subscribe(() => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        this.onFullscreenChange();
                    }, 200);
                });

        }
        else {
            this.fsChangeSubscription = fromEvent(fsElemDispatcher, this.polyfill.onchange)
                .subscribe(() => {
                    this.onFullscreenChange();
                });
        }




        if (VgUtils.shouldUseFakeFullScreen) {
            VgFullscreenAPI.fakeFullScreen = true;
        }
        else if (VgUtils.useFakeFullScreenWhenNotPossible) {
            if (!this.isAvailable || !this.nativeFullscreen) {
                VgFullscreenAPI.fakeFullScreen = true;
            }
        }
        else {
            VgFullscreenAPI.fakeFullScreen = false;
        }

        if(environment.app)
        {
            this.appChangeSubscription = fromEvent(window,"quitFullscreen").subscribe(p=>{
                this.exit();
            })
        }

        //console.log("fakefullscreen", VgFullscreenAPI.fakeFullScreen);
        // VgFullscreenAPI.fakeFullScreen = VgUtils.shouldUseFakeFullScreen 
        // && (!this.isAvailable || !this.nativeFullscreen || this.getChromeVersion() <44);
        //console.log(VgFullscreenAPI.fakeFullScreen)
    }
    // getChromeVersion() {
    //     var raw = window.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    //     return raw ? parseInt(raw[2], 10) : 100;
    // }

    isChrome() {
        // please note, 
        // that IE11 now returns undefined again for window.chrome
        // and new Opera 30 outputs true for window.chrome
        // but needs to check if window.opr is not undefined
        // and new IE Edge outputs to true now for window.chrome
        // and if not iOS Chrome check
        // so use the below updated condition
        var isChromium = window["chrome"];
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = typeof window["chrome"] !== "undefined";
        var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
        var isIOSChrome = winNav.userAgent.match("CriOS");

        if (isIOSChrome) {
            return true;
            // is Google Chrome on IOS
        } else if (
            isChromium !== null &&
            typeof isChromium !== "undefined" &&
            vendorName === "Google Inc." &&
            isOpera === false &&
            isIEedge === false
        ) {
            return true;
            // is Google Chrome
        } else {
            return false;
            // not Google Chrome 
        }

    }
    onFullscreenChange() {
        this.isFullscreen = !!document[this.polyfill.element];
        this.onChangeFullscreen.next(this.isFullscreen);
        //console.log(this.isFullscreen);
        window.dispatchEvent(new CustomEvent("fullscreen", {
            detail: {
                'isfullscreen': this.isFullscreen,
                'isfake': this.useFakeFullScreen()
            }
        }
        ));
    }

    toggleFullscreen(element: any = null) {
        // console.log("toggle fullscreen");
        if (this.isFullscreen) {
            this.exit();
        }
        else {
            this.request(element);
        }

    }

    private useFakeFullScreen() {
        return VgFullscreenAPI.fakeFullScreen;
    }
    request(elem: any) {


        if (!elem) {
            elem = this.videogularElement;
        }

        this.isFullscreen = true;
        this.onChangeFullscreen.next(true);
        if (this.useFakeFullScreen()) {

        }
        else {

            // Perform native full screen support
            if (this.isAvailable && this.nativeFullscreen) {
                // Fullscreen for mobile devices
                if (VgUtils.isMobileDevice()) {
                    // We should make fullscreen the video object if it doesn't have native fullscreen support
                    // Fallback! We can't set vg-player on fullscreen, only video/audio objects
                    if ((!this.polyfill.enabled && elem === this.videogularElement)
                        || VgUtils.isiOSDevice() || VgUtils.shouldUseNative) {
                        elem = this.medias.toArray()[0].elem;
                    }
                    this.enterElementInFullScreen(elem);
                }
                else {
                    
                    this.enterElementInFullScreen(this.videogularElement);
                }
            }
        }



    }

    enterElementInFullScreen(elem: any) {
        elem[this.polyfill.request]({ navigationUI: "hide" });
    }

    exit() {
        this.isFullscreen = false;
        this.onChangeFullscreen.next(false);
        if (this.useFakeFullScreen()) {
        }
        else {
            // Exit from native fullscreen
            if (this.isAvailable
                 && this.nativeFullscreen 
                 && !!document
                ) {
                    try{
                        document[this.polyfill.exit]();
                    }
                    catch(err)
                    {

                    }
            }
        }

    }
}
